var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityAddressCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C16.982 3 21 7.018 21 12C21 16.982 16.982 21 12 21",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.982 3 21 7.018 21 12C21 16.982 16.982 21 12 21",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C7.018 21 3 16.982 3 12C3 7.018 7.018 3 12 3",
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C7.018 21 3 16.982 3 12C3 7.018 7.018 3 12 3",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1675 4.05975C7.2775 8.88475 7.2775 15.1158 10.1675 19.9408C11.0135 21.3538 12.9865 21.3538 13.8325 19.9408C16.7225 15.1158 16.7225 8.88475 13.8325 4.05975C12.9855 2.64675 11.0135 2.64675 10.1675 4.05975Z",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00781 7.85742C8.89981 9.36842 15.0958 9.36842 19.9868 7.85742",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 16.1411C15.0987 14.6301 8.90272 14.6301 4.01172 16.1411",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityAddressCheck);
export default __webpack_public_path__ + "static/media/entity_address_check.3e7813bd3be02b6ea379371b2e6ab1de.svg";
export { ForwardRef as ReactComponent };